import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const OkIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={0}
    fill="currentColor"
    stroke="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.7803 6.21967c.2929.29289.2929.76777 0 1.06066l-10.5 10.49997c-.29286.2929-.76774.2929-1.06063 0l-5.25-5.25c-.29289-.2929-.29289-.7677 0-1.0606.29289-.2929.76777-.2929 1.06066 0L9.75 16.1893l9.9697-9.96963c.2929-.29289.7677-.29289 1.0606 0Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default OkIcon;
